// pages/CreateCampaign/index.jsx
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDBox from "../../components/MDBox";
import MDButton from "../../components/MDButton";
import Icon from "@mui/material/Icon";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import CreateCampaignForm from "./CreateCampaignForm";
import Loader from "../Loader/Loader";
import { createCampaignFB, editCampaign, getOneCampaign } from "../../assets/firebaseFirestore";

const CreateCampaign = () => {
  const [defaultCampaign, setDefaultCampaign] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loader, setLoader] = useState(false);
  const [values, setValues] = useState({
    name: "",
    description: "",
    startDate: "",
    endDate: "",
    budget: "",
    status: "draft",
    regionType: "all",
    region: [],
    active: true,
  });

  const changeValue = (val, key) => {
    setValues({ ...values, [key]: val });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    let obj = { ...values };
    if (id) {
      obj.id = id;
    }
    setLoader(true);
    try {
      if (id) {
        await editCampaign(obj, navigate);
        await setLoader(false);
      } else {
        await createCampaignFB(obj, navigate);
        await setLoader(false);
      }
    } catch (error) {
      console.error("Error saving campaign:", error);
      await setLoader(false);
    }
  };

  useEffect(() => {
    if (id) {
      getOneCampaign(id).then((res) => {
        setValues(res);
        setDefaultCampaign(res);
      });
    }
  }, [id]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {loader && <Loader />}

      <Card>
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <Link to={"/campaigns"}>
            <MDButton variant="gradient" color="primary">
              <Icon sx={{ fontWeight: "bold" }}>arrow_back</Icon>
              &nbsp;Back
            </MDButton>
          </Link>
        </MDBox>

        <CreateCampaignForm
          values={values}
          changeValue={changeValue}
          onSubmit={onSubmit}
          defaultCampaign={defaultCampaign}
        />
      </Card>
    </DashboardLayout>
  );
};

export default CreateCampaign;
